import { render, staticRenderFns } from "./DriverMappingPopUp.vue?vue&type=template&id=646e768a&scoped=true"
import script from "./DriverMappingPopUp.vue?vue&type=script&lang=js"
export * from "./DriverMappingPopUp.vue?vue&type=script&lang=js"
import style0 from "./DriverMappingPopUp.vue?vue&type=style&index=0&id=646e768a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646e768a",
  null
  
)

export default component.exports